export enum DocumentFilterOptionEnum {
  UNREAD = 'unread',
  LOCKED = 'locked',
  JOURNALIZED = 'journalized',
  BEING_JOURNALIZED = 'being_journalized',
  JOURNALIZED_FAILED = 'journalized_failed',
}
